var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTwitterX = function SvgTwitterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8l164.9-188.5L26.8 48h145.6l100.5 132.9L389.2 48zm-24.8 373.8h39.1L151.1 88h-42l255.3 333.8z"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDUxMiA1MTIiPjxwYXRoIGZpbGw9IiMwMDAwMDAiIGQ9Ik0zODkuMiA0OGg3MC42TDMwNS42IDIyNC4yTDQ4NyA0NjRIMzQ1TDIzMy43IDMxOC42TDEwNi41IDQ2NEgzNS44bDE2NC45LTE4OC41TDI2LjggNDhoMTQ1LjZsMTAwLjUgMTMyLjlMMzg5LjIgNDh6bS0yNC44IDM3My44aDM5LjFMMTUxLjEgODhoLTQybDI1NS4zIDMzMy44eiI+PC9wYXRoPjwvc3ZnPg==";
export { SvgTwitterX as ReactComponent };